module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "img-back pull-left",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["提醒"]), " ", _vm._h('router-link', {
    staticClass: "pull-right icon-right icon-setup text-hide",
    attrs: {
      "to": {
        path: '/remind/add'
      },
      "tag": "span"
    }
  }, ["添加提醒"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", " ", " ", _vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', {
    staticClass: "remind-list"
  }, [_vm._h('ul', {
    staticClass: "list-group-item primary"
  }, [_vm._l((_vm.remindTimeList), function(item) {
    return _vm._h('router-link', {
      staticClass: "list-group",
      attrs: {
        "to": {
          path: '/remind/edit/' + item.curcheHandsTimeId
        },
        "tag": "li"
      }
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('div', {
      staticClass: "clearfix"
    }, [_vm._h('div', [_vm._h('span', {
      staticClass: "font-18 block"
    }, [_vm._s(item.handsTime)]), " ", _vm._h('p', {
      staticClass: "font-12 gray"
    }, [_vm._l((item.weekList), function(week) {
      return _vm._h('span', [_vm._s(week.week) + "  "])
    })])]), " ", _vm._h('div', {
      staticClass: "pull-right",
      staticStyle: {
        "margin-top": "-35px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setTimeState(item)
        }
      }
    }, [_vm._h('div', {
      staticClass: "mint-switch"
    }, [(item.stateFlag) ? _vm._h('input', {
      staticClass: "mint-switch-input",
      attrs: {
        "type": "checkbox",
        "checked": ""
      }
    }) : _vm._h('input', {
      staticClass: "mint-switch-input",
      attrs: {
        "type": "checkbox"
      }
    }), " ", " ", _vm._h('span', {
      staticClass: "mint-switch-core"
    }), " ", _vm._h('div', {
      staticClass: "mint-switch-label"
    })])])])])
  }), " "]), " ", _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "padding-15"
  }, [_vm._h('span', {
    staticClass: "font-14 block"
  }, ["温馨提示"]), " ", _vm._h('p', {
    staticClass: "gray font-12",
    staticStyle: {
      "margin-top": "5px"
    }
  }, ["设置提醒消息后，系统在您指定的时间内自动向指定的家长APP上发送一条提醒消息，消息文字您可以自由编写！"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-4bc75142!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/remind/remindList.vue
// module id = 199
// module chunks = 1